import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { Logo } from './Logo';
import { clinic, patientLinks } from '../../data/clinic';
const careLinks = [{
  label: 'Pijnklachten',
  to: '/pijnbehandelingen'
}, {
  label: 'Behandelingen',
  to: '/behandelingen'
}, {
  label: 'Voor verwijzers',
  to: '/verwijzers'
}, {
  label: 'Over ons',
  to: '/over-ons'
}, {
  label: 'Ervaringen',
  to: '/ervaringen'
}, {
  label: 'Vacatures',
  to: '/vacatures'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function Footer() {
  return <footer className="bg-ink text-white" data-id="element-154" data-mp="3n3k9u6dm4nqe">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-12 lg:px-8 lg:py-20" data-id="element-155" data-mp="3n4lun2kfkolb">
        <div className="lg:col-span-4" data-id="element-156" data-mp="3j30g7cs90290">
          <Logo tone="light" data-id="element-157" data-mp="3j05sncdxu1bd" />
          <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-white/70" data-id="element-158" data-mp="3e3feiulp1fsl">
            Onafhankelijk specialistisch pijnbehandelcentrum in Velsen-Noord. Behandeling door anesthesioloog-pijnspecialisten
            en (pijn)verpleegkundigen.
          </p>
          <ul className="mt-6 flex gap-5" data-id="element-159" data-mp="2kb0b9q1v7f1h">
            {clinic.socials.map(s => <li key={s.label} data-id="element-160" data-mp="2p54h25ze9h0z">
                <a href={s.href} target="_blank" rel="noreferrer" className="text-sm font-medium text-cyan hover:text-white" data-id="element-161" data-mp="2bcerjrknptz4">
                  {s.label}
                </a>
              </li>)}
          </ul>
        </div>

        <nav aria-label="Zorg" className="lg:col-span-2" data-id="element-162" data-mp="3425aqf15bm23">
          <h2 className="font-display text-base font-semibold" data-id="element-163" data-mp="382p6be62mhm4">Zorg</h2>
          <ul className="mt-4 space-y-2.5" data-id="element-164" data-mp="381w6yy9fyue0">
            {careLinks.map(item => <li key={item.to} data-id="element-165" data-mp="2u2ef2a0un10f">
                <Link to={item.to} className="text-[15px] text-white/70 hover:text-white" data-id="element-166" data-mp="2u5agw9fti9u5">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <nav aria-label="Voor patiënten" className="lg:col-span-3" data-id="element-167" data-mp="1nmuc3inppeul">
          <h2 className="font-display text-base font-semibold" data-id="element-168" data-mp="1no5fhhd8wkl6">Voor patiënten</h2>
          <ul className="mt-4 space-y-2.5" data-id="element-169" data-mp="13jg133iax5yt">
            {patientLinks.map(item => <li key={item.label} data-id="element-170" data-mp="zk76jwfft427">
                {item.external ? <a href={item.to} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-[15px] text-white/70 hover:text-white" data-id="element-171" data-mp="urw52p51ta7j">
                    {item.label}
                    <ArrowUpRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-172" data-mp="ktzxu8f8ezep" />
                  </a> : <Link to={item.to} className="text-[15px] text-white/70 hover:text-white" data-id="element-173" data-mp="fu3rw3mz4xwi">
                    {item.label}
                  </Link>}
              </li>)}
          </ul>
        </nav>

        <div className="lg:col-span-3" data-id="element-174" data-mp="6w1nde417n4h">
          <h2 className="font-display text-base font-semibold" data-id="element-175" data-mp="267b21sx9c22n">Bezoek & contact</h2>
          <address className="mt-4 space-y-3 text-[15px] not-italic text-white/70" data-id="element-176" data-mp="2658d7c7ucezi">
            <p data-id="element-177" data-mp="216ey5fcwofx8">
              {clinic.street}
              <br data-id="element-178" data-mp="28sskovguukp3" />
              {clinic.postalCode} {clinic.city}
            </p>
            <p data-id="element-179" data-mp="2dqu4jim3uo1m">
              <a href={clinic.phoneHref} className="font-semibold text-cyan hover:text-white" data-id="element-180" data-mp="2dqbyju9n4vgi">
                {clinic.phone}
              </a>
              <br data-id="element-181" data-mp="2iilt5nlpajp4" />
              <a href={`mailto:${clinic.email}`} className="break-all hover:text-white" data-id="element-182" data-mp="2ik6hgvhf96ej">
                {clinic.email}
              </a>
            </p>
            <p data-id="element-183" data-mp="1pug9l46dv0qv">{clinic.hours}</p>
          </address>
        </div>
      </div>
      <div className="border-t border-white/10" data-id="element-184" data-mp="1urpymipv1ae6">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-5 py-6 text-sm text-white/60 sm:flex-row sm:justify-between lg:px-8" data-id="element-185" data-mp="1uuc2o8djl7rn">
          <p data-id="element-186" data-mp="23so4z7nrttzx">© 2026 Excellent Care Clinics</p>
          <div className="flex gap-6" data-id="element-187" data-mp="23uh9agaww24r">
            <Link to="/klachteninformatie" className="hover:text-white" data-id="element-188" data-mp="3b6hooozja5kb">
              Klachteninformatie
            </Link>
            <a href={clinic.termsPdf} target="_blank" rel="noreferrer" className="hover:text-white" data-id="element-189" data-mp="3f7be5msmjsfb">
              Algemene voorwaarden
            </a>
          </div>
        </div>
      </div>
    </footer>;
}